import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { LABEL_NOT_AVAILABLE } from '../../../../shared/lib/constants';
import palette from '../../../../shared/lib/theme/palette';
import { TransactionsHistoryChipStyle } from '../../../../shared/lib/theme/styleComponents';
import { transactionHistoryCell } from '../../../../shared/lib/theme/styleConstants';
import { capitalizeFirstWord, centToDollar, humanize } from '../../../../shared/lib/utils';
import { DisplayTransactionHistoryItemProps } from '../../app/interfaceTypes';

export const DisplayTransactionHistoryItem: FC<DisplayTransactionHistoryItemProps> = ({ index, invoice }) => {
  const { source, failure_message } = invoice?.charge || {};
  const { hosted_invoice_url, amount_paid: amount, created, status, billing_reason, total_discount_amounts, description, charge } = invoice ?? {};
  const { payment_method_details } = charge || {};
  const { card } = payment_method_details || {};
  const { last4: cardLast4, brand } = card || {};
  const { amount: discountAmount } = total_discount_amounts?.[0] ?? {};
  const { last4 } = source || {};
  const isSucceeded = status === 'paid'; // Status can be "succeeded"/"pending"/"failed"
  const { blackOne, greenOne, red } = palette;
  const createdAt = created && moment.tz(moment.unix(parseInt(created.toString() || '')), 'UTC');

  return (
    <TableRow key={index}>
      <TableCell>
        <Typography variant="subtitle2" color="inherit">
          {createdAt && createdAt.format('MM/DD/YYYY')}
        </Typography>

        <Typography variant="subtitle2" sx={{ fontWeight: '500', color: palette.blackTwo }}>
          {createdAt && createdAt.format('h:mm A')}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="subtitle2" sx={{ color: blackOne }}>
          {humanize(description ? description : (billing_reason ?? '')) || LABEL_NOT_AVAILABLE}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="subtitle2" sx={transactionHistoryCell}>
          {brand || source?.brand ? 'Credit Card' : LABEL_NOT_AVAILABLE}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="subtitle2" sx={transactionHistoryCell}>
          {last4 || cardLast4 || LABEL_NOT_AVAILABLE}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="subtitle2" sx={{ color: blackOne }}>
          {!!amount ? `$${centToDollar(amount)}` : '$0.00'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="subtitle2" sx={{ color: blackOne }}>
          {total_discount_amounts?.[0] ? `$${centToDollar(discountAmount || 0)}` : '$0.00'}
        </Typography>
      </TableCell>

      <TableCell>
        {hosted_invoice_url ? (
          <Link to={hosted_invoice_url} target="_blank" rel="noopener noreferrer">
            <ReceiptLongIcon color="primary" />
          </Link>
        ) : (
          <ReceiptLongIcon color="disabled" />
        )}
      </TableCell>

      <TableCell>
        <Tooltip title={failure_message} sx={{ cursor: 'default' }}>
          <TransactionsHistoryChipStyle size="small" label={isSucceeded ? 'Paid' : status && capitalizeFirstWord(status)} customcolor={isSucceeded ? greenOne : red} />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};
